import { createI18n } from 'vue-i18n'
import { messages, localeNames, localeOptions } from '../locales'

// 获取保存的语言设置，如果没有则使用浏览器语言或默认中文
function getDefaultLocale() {
  // 1. 先检查本地存储
  const saved = localStorage.getItem('locale')
  if (saved && messages[saved]) {
    return saved
  }

  // 2. 尝试检测浏览器语言
  const browserLang = navigator.language || navigator.userLanguage
  if (browserLang) {
    // 精确匹配
    if (messages[browserLang]) {
      return browserLang
    }
    // 尝试匹配语言前缀 (如 zh-TW -> zh-CN)
    const langPrefix = browserLang.split('-')[0]
    if (langPrefix === 'zh') {
      return 'zh-CN'
    }
    if (langPrefix === 'en') {
      return 'en-US'
    }
  }

  // 3. 默认中文
  return 'zh-CN'
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  globalInjection: true, // 全局注入 $t 方法
  locale: getDefaultLocale(),
  fallbackLocale: 'zh-CN', // 回退语言
  messages,
  silentTranslationWarn: true, // 静默翻译警告
  silentFallbackWarn: true, // 静默回退警告
})

// 切换语言的函数
export function setLocale(locale) {
  if (messages[locale]) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
    // 更新 HTML lang 属性
    document.documentElement.lang = locale
    // 触发自定义事件以便其他组件响应
    window.dispatchEvent(new CustomEvent('locale-changed', { detail: { locale } }))
  }
}

// 获取当前语言
export function getLocale() {
  return i18n.global.locale.value
}

// 获取所有可用语言
export function getAvailableLocales() {
  return localeOptions
}

// 获取语言名称
export function getLocaleName(locale) {
  return localeNames[locale] || locale
}

// 切换到下一个语言（用于快速切换）
export function toggleLocale() {
  const current = getLocale()
  const locales = Object.keys(messages)
  const currentIndex = locales.indexOf(current)
  const nextIndex = (currentIndex + 1) % locales.length
  setLocale(locales[nextIndex])
  return locales[nextIndex]
}

export { localeNames, localeOptions }
export default i18n
